import React from 'react';
import { fromPairs, map, isEqual, filter } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { editMemberSecuritySettings as EditMemberSecuritySettings } from 'ui/views/widgets/editMemberSecuritySettings';
 *
 * // render
 * <EditMemberSecuritySettings propName='propValue'/>
 */
export const editMemberSecuritySettings = ( props ) => {

    const actions = filter( props.actions, ( action ) => 'close' !== action.name );
    
    return (
        <div className='ui-edit-member-security-settings'>
            <div className='ui-edit-member-security-settings__header'>

                {/* title for the modal */}
                <div className='ui-edit-member-security-settings__header__title'>
                    { getLabel( props.addTitle ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

            <div className='ui-edit-member-security-settings__body'>

				{/* title for the drug preference */}
				<Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.itemData.values } // default values
                    isValid={ false }
                    mode={ props.mode }
                    onSubmit={ ( { isValid, values } ) => {
                        if( isValid ) {
                            props.onSumbitClick( {
                                email: values.email
                            } );
                        }
                    } }
                >
                    { ( { fields, values, /*isValid,*/ errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-edit-member-security-settings__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {
                                    
                                    return (
                                        <>
                                        {/* {! isNil( props.iconName ) ? ( */}
                                            {/* <div className='ui-edit-member-security-settings__body__icon'>
                                                <Icon name='individual' width='20' height='20' />
                                            </div> */}
                                        {/* ) : null } */}

                                        <field.view
                                            className='ui-edit-member-security-settings__body__form__field'
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                        />
                                        </>
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-edit-member-security-settings__body__form__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                
                                                //disabled={ 'cancel' !== action.name ? !isValid : false }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='medium'
                                                className='ui-edit-member-security-settings__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => props.onCancelClick() : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
			</div>
        </div>
    );
};

// set display name
editMemberSecuritySettings.displayName = 'editMemberSecuritySettings';

// set default props
editMemberSecuritySettings.defaultProps = {};

// prop types
editMemberSecuritySettings.propTypes = {};
